import { useState } from 'react';
import { AdminGuard } from '@/components/admin/AdminGuard';
import { AdminOverviewCards } from '@/components/admin/AdminOverviewCards';
import { UserManagementTable } from '@/components/admin/UserManagementTable';
import { UserDetailModal } from '@/components/admin/UserDetailModal';
import { AdminAuditLog } from '@/components/admin/AdminAuditLog';
import { AdminUser } from '@/types/admin';
import { Shield, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

export function Admin() {
  const [selectedUser, setSelectedUser] = useState<string | null>(null);

  return (
    <AdminGuard>
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-2">
              <Shield className="w-8 h-8 text-blue-600" />
              <h1 className="text-3xl font-bold text-gray-900">Admin Dashboard</h1>
            </div>
            <p className="text-gray-600">Manage users and view platform analytics</p>
          </div>

          {/* Quick Links */}
          <div className="mb-6 flex flex-wrap gap-3">
            <Link
              to="/admin/prompts"
              className="inline-flex items-center gap-2 px-4 py-2 bg-purple-100 text-purple-700 rounded-lg hover:bg-purple-200 transition-colors"
            >
              <FileText className="w-4 h-4" />
              Prompt Management
            </Link>
          </div>

          <AdminOverviewCards />

          <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
            <div className="xl:col-span-2">
              <div className="bg-white rounded-lg shadow-sm p-6">
                <h2 className="text-xl font-semibold mb-4 text-gray-900">User Management</h2>
                <UserManagementTable onViewUser={(user: AdminUser) => setSelectedUser(user.userId)} />
              </div>
            </div>
            <AdminAuditLog />
          </div>
        </div>

        {selectedUser && (
          <UserDetailModal
            userId={selectedUser}
            isOpen={!!selectedUser}
            onClose={() => setSelectedUser(null)}
          />
        )}
      </div>
    </AdminGuard>
  );
}
